import React, { useCallback, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useLocation } from 'react-router-dom';
import { globalStore } from '../../GlobalStore';
import { readAppOpenBaseLink } from '../../utils/AppDownloadUrlConfig';
import { buildAppOpenUrl, detectMobileOs } from '../../utils/AppOpenLinkUtil';
import { LoginModalConfig } from '../../components/LoginModal/LoginModalConfig';
import './HelloAppH5Style.css';

export type HelloAppH5Role = 'buyer' | 'seller';

export interface HelloAppH5PageProps {
  role: HelloAppH5Role;
  documentTitle: string;
  buttonLabel: string;
  backgroundImageUrl: string;
  placeholderBackgroundColor: string;
  buttonBackgroundColor?: string;
  buttonTextColor?: string;
}

const HelloAppH5Page: React.FC<HelloAppH5PageProps> = observer(
  ({
    role,
    documentTitle,
    buttonLabel,
    backgroundImageUrl,
    placeholderBackgroundColor,
    buttonBackgroundColor = LoginModalConfig.primaryColor,
    buttonTextColor = '#ffffff',
  }) => {
    const location = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
      document.title = documentTitle;
    }, [documentTitle]);

    const resolveOpenUrl = useCallback((): string => {
      const os = detectMobileOs();
      const baseLink = readAppOpenBaseLink(globalStore.basicConfigs, role, os);
      return buildAppOpenUrl(baseLink, location.pathname, location.search);
    }, [location.pathname, location.search, role]);

    const handleOpenApp = () => {
      const url = resolveOpenUrl();
      if (!url) {
        console.warn('[HelloAppH5] 未配置唤起链接，请在 BDD appDownloadUrl 中填写 Universal Link / App Link');
        return;
      }
      console.log('[HelloAppH5] 打开 APP 链接:', url);
      window.location.href = url;
    };

    const openUrl = resolveOpenUrl();

    return (
      <div className="hello-app-h5-page">
        <div
          className="hello-app-h5-bg"
          style={{
            backgroundColor: placeholderBackgroundColor,
            backgroundImage: `url(${backgroundImageUrl})`,
          }}
          aria-hidden
        />
        <div className="hello-app-h5-btn-wrap">
          <button
            type="button"
            className="hello-app-h5-open-btn"
            style={{
              backgroundColor: buttonBackgroundColor,
              color: buttonTextColor,
              opacity: 1,
            }}
            aria-disabled={!openUrl}
            onClick={handleOpenApp}
          >
            {buttonLabel}
          </button>
        </div>
      </div>
    );
  }
);

export default HelloAppH5Page;
